import React, { createContext, useContext, useState, useCallback } from 'react';
import { Toast as ToastType, ToastContextType } from '../../shared/types/toast';
import Toast from './toast';
import './toast.css';

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastType[]>([]);

  const addToast = useCallback((toastData: Omit<ToastType, 'id'>) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    const toast: ToastType = {
      id,
      duration: 5000,
      ...toastData,
    };

    setToasts(prev => [toast, ...prev]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const clearToasts = useCallback(() => {
    setToasts([]);
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, addToast, removeToast, clearToasts }}>
      {children}
      
      <div className="arqite-toast-container">
        {toasts.map(toast => (
          <Toast
            key={toast.id}
            toast={toast}
            onRemove={removeToast}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
